import { useCallback, useEffect, useState } from "react";
import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";
import { DefaultDatePicker } from "../../../../../../common/components/masked_inputs/default_date_picker_input";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

/**
 * MapaConcretagemAprovFinalModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  idFuncionario: number | null;
  funcionarioDropdown: FuncionarioDropDown[];
  onClose: () => void;
  onSubmit: (idFuncionario: number) => void;
};

export const MapaConcretagemAprovFinalModal = ({
  open,
  saving,
  loading,
  idFuncionario,
  funcionarioDropdown,
  onClose,
  onSubmit,
}: Props) => {

  const [funcionarioSelecionado, setFuncionarioSelecionado] = useState<FuncionarioDropDown | null>(null);

  useEffect(() => {
    if (open) {
      if (idFuncionario !== null && funcionarioDropdown.length > 0) {
        const funcionario = funcionarioDropdown.find(f => f.idFuncionario === idFuncionario);
        setFuncionarioSelecionado(funcionario ?? null);
      }
    }
  }, [
    open,
    idFuncionario,
    funcionarioDropdown,
  ]);

  const handleSubmit = useCallback(() => {
    if (funcionarioSelecionado && funcionarioSelecionado.idFuncionario) {
      onSubmit(funcionarioSelecionado.idFuncionario);
    }
  }, [
    funcionarioSelecionado,
    onSubmit,
  ]);

  return (
    <BaseControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="sm"
      title="Aprovação mapa de concretagem"
      onClose={onClose}
      onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4 my-2">
        <DefaultAutocomplete
          label="Aprovador"
          getOptionDisabled={x => !x.canBeSelected}
          getOptionLabel={x => x.nome}
          getOptionKey={x => x.idFuncionario}
          value={funcionarioSelecionado}
          options={funcionarioDropdown}
          onChange={e => setFuncionarioSelecionado(e ?? null)}
        />

        <DefaultDatePicker
          name="dataAprovacao"
          readOnly={true}
          value={new Date()}
          label="Data de aprovação"
          onChangeValue={() => { }}
        />
      </div>
    </BaseControlledModal>
  );
}